const scope = 'loop/News';

export const REQUEST_NEWS = `${scope}/REQUEST_NEWS`;
export const REQUEST_NEWS_BY_CATEGORY = `${scope}/REQUEST_NEWS_BY_CATEGORY`;
export const REQUEST_NEWS_SUCCESS = `${scope}/REQUEST_NEWS_SUCCESS`;
export const REQUEST_NEWS_ERROR = `${scope}/REQUEST_NEWS_ERROR`;

export const DELETE_NEWS = `${scope}/DELETE_NEWS`;
export const DELETE_NEWS_SUCCESS = `${scope}/DELETE_NEWS_SUCCESS`;
export const DELETE_NEWS_ERROR = `${scope}/DELETE_NEWS_ERROR`;

export const EDIT_NEWS = `${scope}/EDIT_NEWS`;
export const EDIT_NEWS_SUCCESS = `${scope}/EDIT_NEWS_SUCCESS`;
export const EDIT_NEWS_ERROR = `${scope}/EDIT_NEWS_ERROR`;

export const NEWS_CLOSE_SUCCES_MODAL = `${scope}/NEWS_CLOSE_SUCCES_MODAL`;

export const GET_SINGLE_NEWS = `${scope}/GET_SINGLE_NEWS`;
export const GET_SINGLE_NEWS_SUCCESS = `${scope}/GET_SINGLE_NEWS_SUCCESS`;
export const GET_SINGLE_NEWS_ERROR = `${scope}/GET_SINGLE_NEWS_ERROR`;

// Const Get Most Read News By Category
export const GET_MOST_READ_NEWS_BY_CATEGORY = `${scope}/GET_MOST_READ_NEWS_BY_CATEGORY`;
export const GET_MOST_READ_NEWS_BY_CATEGORY_SUCCESS = `${scope}/GET_MOST_READ_NEWS_BY_CATEGORY_EVENTS_SUCCESS`;
export const GET_MOST_READ_NEWS_BY_CATEGORY_ERROR = `${scope}/GET_MOST_READ_NEWS_BY_CATEGORY_ERROR`;

// Export Most Read News
export const MOST_READ_NEWS = `${scope}/MOST_READ_NEWS`;
export const MOST_READ_NEWS_SUCCESS = `${scope}/MOST_READ_NEWS_SUCCESS`;
export const MOST_READ_NEWS_ERROR = `${scope}/MOST_READ_NEWS_ERROR;`

// Per Page
export const NEWS_ITEMS_PER_PAGE = 12;
export const MOST_READ_NEWS_ITEMS_PER_PAGE = 4;
